import { Reward } from '../types';
import { AppState } from '../../rootReducer';
import { RewardsState } from '../types';

export const getState = (state: AppState): RewardsState => state.rewardsReducer;

export const getRewardsList = (state: AppState): Reward[] => state.rewardsReducer.rewards || [];

export const isLoading = (state: AppState): boolean => state.rewardsReducer.isLoading;
